export default __webpack_public_path__ + "static/media/web.32de40da.config";